import classNames from 'classnames'
import btUidBg from 'platform-config/src/assets/image/common/bt-uid.png'
import { useUserInfoStore } from 'store'
import './Uid.scss'

export const Uid = defineComponent({
  name: 'Uid',
  setup() {
    const userInfoStore = useUserInfoStore()

    const isBtUid = computed(() => {
      return !!userInfoStore.userInfo?.userInfo?.isBtUserId
    })

    return () => (
      <div
        class={classNames('uid-layout', {
          'is-bt-uid': isBtUid.value,
        })}
      >
        {isBtUid.value && <img src={btUidBg} alt="bt-uid" />}
        <span>{isBtUid.value ? userInfoStore.userInfo?.userInfo?.btUserId : userInfoStore.userInfo?.userId}</span>
      </div>
    )
  },
})
